import PropTypes from 'prop-types';

import { ProductAdditionalInfo as SourceProductAdditionalInfo } from 'AdvoxComponent/ProductAdditionalInfo/ProductAdditionalInfo.component.js';
import Icons from 'Component/Icons';
import { isSignedIn } from 'Util/Auth';
import { formatPrice } from 'Util/Price';

import './ProductAdditionalInfo.override.style.scss';
/** @namespace Pwa/Component/ProductAdditionalInfo/Component */
export class ProductAdditionalInfo extends SourceProductAdditionalInfo {
    static propTypes = {
        onMyAccountButtonClick: PropTypes.func.isRequired,
    };

    state = {
        ...this.state,
        showAdditionalMethods: false,
    };

    renderShippingCost() {
        const { inpostEnabled, inpostFreeAbove, productPrice, shippingCosts } = this.props;

        if (inpostFreeAbove && +inpostEnabled === 1 && productPrice >= +inpostFreeAbove) return __('Free Delivery');

        if (!shippingCosts || shippingCosts === '') return __('No data');

        const {
            value: { value, currency },
        } = shippingCosts;

        return formatPrice(value, currency);
    }

    renderAdditionalMethods() {
        const { shippingCostsAdditional, shippingCosts, isMobile, isTablet } = this.props;
        const { showAdditionalMethods } = this.state;
        if (!shippingCostsAdditional) return null;

        const parcelMachine = [shippingCosts]?.map(({ label, value: { value, currency } }) => (
            <tr key={label}>
                <td>{label}</td>
                <td>{formatPrice(value, currency)}</td>
            </tr>
        ));

        return (
            <div block="ProductAdditionalInfo" elem="AdditionalMethods" mods={{ showAdditionalMethods }}>
                {isMobile || isTablet ? (
                    <div
                        block="ProductAdditionalInfo"
                        elem="AdditionalMethodsClose"
                        onClick={this.closeAdditionalMethods.bind(this)}
                    >
                        <Icons name="close" width="24" height="24" fill="#fff" />
                    </div>
                ) : null}
                <table>
                    <thead>
                        <tr>
                            <th colSpan="2">{__('Other shipping options')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {shippingCostsAdditional.map(({ label, value: { value, currency } }) => (
                            <tr key={label}>
                                <td>{label}</td>
                                <td>{formatPrice(value, currency)}</td>
                            </tr>
                        ))}
                        {parcelMachine}
                    </tbody>
                </table>
            </div>
        );
    }

    showAdditionalMethods() {
        const { showAdditionalMethods } = this.state;
        this.setState({ showAdditionalMethods: !showAdditionalMethods });
    }

    closeAdditionalMethods() {
        this.setState({ showAdditionalMethods: false });
    }

    renderContent() {
        const {
            calculatedDeliveryTime,
            onMyAccountButtonClick,
            showAlternativeDesign,
            shippingTime,
            shippingTimeEnabled,
        } = this.props;

        return (
            <div block="ProductAdditionalInfo" mods={{ alternative: showAlternativeDesign }}>
                {shippingTimeEnabled === '1' ? (
                    <div block="ProductAdditionalInfo" elem="Item">
                        <div block="ProductAdditionalInfo" elem="Icon">
                            <Icons name="clock_2" width="24" height="24" fill="#A1A1A1" />
                        </div>
                        <div block="ProductAdditionalInfo" elem="Text">
                            <div>{__('Delivery time:')}</div>
                            <div>{calculatedDeliveryTime || shippingTime || __('No data')}</div>
                        </div>
                        <div block="ProductAdditionalInfo" elem="Angle">
                            <Icons name="angle_right" width="12" height="12" fill="#000" />
                        </div>
                    </div>
                ) : null}
                <div block="ProductAdditionalInfo" elem="Item">
                    <div block="ProductAdditionalInfo" elem="Icon">
                        <Icons name="saving_coins" width="24" height="24" fill="#A1A1A1" />
                    </div>
                    <div block="ProductAdditionalInfo" elem="Text">
                        <div>{__('Pay with points')}</div>
                        <div>
                            {isSignedIn() ? (
                                ''
                            ) : (
                                <span
                                    block="ProductAdditionalInfo"
                                    elem="ItemClickAble"
                                    onClick={onMyAccountButtonClick}
                                >
                                    {__('Login')}
                                </span>
                            )}
                        </div>
                    </div>
                    <div block="ProductAdditionalInfo" elem="Angle">
                        <Icons name="angle_right" width="12" height="12" fill="#000" />
                    </div>
                </div>
                <div block="ProductAdditionalInfo" elem="Item">
                    <div
                        onMouseEnter={this.showAdditionalMethods.bind(this)}
                        onMouseLeave={this.showAdditionalMethods.bind(this)}
                        block="ProductAdditionalInfo"
                        elem="Icon"
                    >
                        <Icons name="info" width="24" height="24" fill="#A1A1A1" />
                    </div>
                    <div block="ProductAdditionalInfo" elem="Text">
                        <div>{__('Shipping cost:')}</div>
                        <div>{this.renderShippingCost()}</div>
                    </div>
                    <div block="ProductAdditionalInfo" elem="Angle">
                        <Icons name="angle_right" width="12" height="12" fill="#000" />
                    </div>
                </div>
                <div block="ProductAdditionalInfo" elem="Item">
                    <div block="ProductAdditionalInfo" elem="Icon">
                        <Icons name="return_arrow" width="24" height="24" fill="#A1A1A1" />
                    </div>
                    <div block="ProductAdditionalInfo" elem="Text">
                        <div>{__('Returns:')}</div>
                        <div>{__('365 days for return')}</div>
                    </div>
                    <div block="ProductAdditionalInfo" elem="Angle">
                        <Icons name="angle_right" width="12" height="12" fill="#000" />
                    </div>
                </div>
                {this.renderAdditionalMethods()}
            </div>
        );
    }

    render() {
        return <>{this.renderContent()}</>;
    }
}

export default ProductAdditionalInfo;
